import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startFrom", "continueCheckbox", "lineInput", "previewLine"]
  static values = { nextSequence: Number }

  connect() {
    this.customValue = this.startFromTarget.value
    this.toggleSequence()
    this.updatePreview()
  }

  toggleSequence() {
    const checked = this.continueCheckboxTarget.checked
    this.startFromTarget.disabled = checked
    if (checked) {
      this.customValue = this.startFromTarget.value
      this.startFromTarget.value = this.nextSequenceValue
    } else {
      this.startFromTarget.value = this.customValue
    }
    this.updatePreview()
  }

  updatePreview() {
    this.lineInputTargets.forEach((input) => {
      const index = input.dataset.lineIndex
      const target = this.previewLineTargets.find((el) => el.dataset.lineIndex === index)
      if (target) target.textContent = input.value
    })

    const numberEl = this.previewLineTargets.find((el) => el.dataset.lineIndex === "5")
    if (numberEl) {
      const num = this.startFromTarget.value
      const digits = num.toString().length
      const size = digits >= 8 ? "12px" : digits >= 7 ? "14px" : digits >= 6 ? "16px" : "18px"
      numberEl.style.fontSize = size
      numberEl.textContent = num
    }
  }
}
